class MoneyController {

    constructor(moneyService, configService) {
        this.moneyService = moneyService;
        this.configService = configService;
    }

    formatAmount () {
        if (this.decorate) {
            this.decorate = this.decorate.toUpperCase();
            switch (this.decorate) {
                case 'GBP':
                case 'EUR':
                case 'USD':
                case 'JPY':
                    this.currencyCode = this.decorate;
                    break;

                default:
                    this.currencyCode = this.configService.get('currency') || 'GBP';
                    break;
            }
        }

        if (!isNaN(this.amount)) {
            this.currency = this.moneyService.getCurrencyDetails(this.currencyCode || null);
            let amount = (this.amount / this.currency.magnitude).toFixed(this.currency.decimals);

            if (this.round) {
                amount = parseInt(amount);
            }

            if (this.decorate) {
                amount = this.decorateValue(amount);
            }

            return amount;
        }
    }

    decorateValue (amount) {
        switch (this.decorate) {
            default:
            case 'true':
            case 'currency':
            case '#':
            case '=':
                amount = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                amount = this.currency.symbol + amount;
                break;

            case '%':
            case 'percent':
            case 'percentage':
                amount = amount.toString().replace('.00', '');
                amount = amount + '%';
                break;
        }

        return amount;
    }
}

MoneyController.$inject = ['moneyService', 'configService'];

export default MoneyController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/base/controllers/money.controller.js